export default __webpack_public_path__ + "static/media/call-decline.e76213cd.svg";